import { getAuth } from 'firebase/auth';

// const BASE_URL = "https://compendium.thisispix.com/api";
const BASE_URL = `${process.env.VUE_APP_API_BASE_URL}/api`;

function prefixImageUrl(imageUrl) {
    return `${process.env.VUE_APP_API_BASE_URL}${imageUrl}`;
}

async function fetchDisciplines(locale = 'nl') {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/disciplines?locale=${locale}&all=1`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching disciplines:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchDiscipline(id) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/discipline/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching discipline:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchDetailedDisciplines(locale = 'nl') {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/disciplines/detailed?locale=${locale}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching disciplines:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchUsers(offset, limit) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/users?offset=${offset}&limit=${limit}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchUser(userId) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/user/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchUserVouchers(userId) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/vouchers/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function searchUsers(query) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/users?search=${query}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function migrateUser(userId) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/tasks/aggregate_user`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId: userId })
        });
        if (!response.ok) {
            return response;
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching users:', error);
        return error;
    }
}

async function downloadUsersCsv() {
    const auth = getAuth();
    const token = await auth.currentUser.getIdToken();
    await fetch(`${BASE_URL}/users/csv`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        responseType: 'blob'
    }).then(response => {
        console.log(response);
        if (response.ok) {
            //let contentType = response.headers.get('content-type');
            return response.blob();
        }
    }).then((response) => {
        // create file link in browser's memory
        const blob = new Blob([response], { type: "text/csv" })
        //const href = URL.createObjectURL(response.data);
        const href = URL.createObjectURL(blob)

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'compendium-users.csv'); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    });
}

async function fetchPromos() {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/promos`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching promos:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchQuestions(locale = 'nl', disciplineId = null) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const endpoint = disciplineId
            ? `${BASE_URL}/discipline/${disciplineId}/all_questions?locale=${locale}`
            : `${BASE_URL}/questions/all?locale=${locale}`;
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchQuestionsWithMedia(locale = 'nl') {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const endpoint = `${BASE_URL}/questions/media?locale=${locale}`;
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchAllMedia() {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const endpoint = `${BASE_URL}/media`;
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function uploadCsv(formData) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/questions/import`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: formData
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function runQualityChecks() {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/check`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error checking quality:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function uploadMedia(formData) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/media`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: formData
        });
        // if (!response.ok) {
        //     throw new Error('Network response was not ok');
        // }
        return await response.json();
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function uploadPromo(formData) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/promos`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: formData
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function createDiscipline(discipline) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/discipline`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(discipline)
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error creating discipline:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function setDisciplineImage(formData) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/disciplineimage`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                // 'Content-Type': 'application/json'
            },
            body: formData
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error creating discipline:', error);
        throw error; // Re-throw to handle it in the component
    }
}

// async function createBattle(battle) {
//     try {
//         console.log(`Creating battle: ${JSON.stringify(battle)}`);
//         const auth = getAuth();
//         const token = await auth.currentUser.getIdToken();
//         const response = await fetch(`${BASE_URL}/battles`, {
//             method: 'POST',
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(battle)
//         });
//         if (!response.ok) {
//             throw new Error('Network response was not ok');
//         }
//         return await response.json();
//     } catch (error) {
//         console.error('Error creating battle:', error);
//         throw error; // Re-throw to handle it in the component
//     }
// }

async function uploadBattle(formData) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/battles`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                // 'Content-Type': 'application/json'
            },
            body: formData
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error creating battle:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchBattle(battleId) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        // Pass a fixed locale. We don't care about the locale, but the backend needs one to fetch the questions
        const endpoint = `${BASE_URL}/battles/${battleId}?locale=en`;
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching battles:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchBattles() {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const endpoint = `${BASE_URL}/battles/all?locale=en`;
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching battles:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchBattleLeaderboard(battleId) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const endpoint = `${BASE_URL}/battles/${battleId}/leaderboard`;
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error(`Error fetching leaderboard ${battleId} `, error);
        throw error; // Re-throw to handle it in the component
    }
}

async function startBattle(battleId) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const endpoint = `${BASE_URL}/battles/${battleId}/start`;
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error(`Error starting battle ${battleId} `, error);
        throw error; // Re-throw to handle it in the component
    }
}

async function stopBattle(battleId) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const endpoint = `${BASE_URL}/battles/${battleId}/stop`;
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error(`Error stopping battle ${battleId} `, error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchVouchers(filteredType) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/vouchers?filter=${filteredType}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching vouchers:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchUserSubscriptions(userId) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/subscriptions/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching vouchers:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function createVouchers(amount, type, durationDays) {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/vouchers/create`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ amount: amount, type: type, duration: durationDays })
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error creating vouchers:', error);
        throw error; // Re-throw to handle it in the component
    }
}

async function fetchSubscriptions() {
    try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken();
        const response = await fetch(`${BASE_URL}/subscriptions`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error('Error fetching subscriptions:', error);
        throw error; // Re-throw to handle it in the component
    }
}

export {
    fetchDiscipline,
    fetchDisciplines,
    fetchDetailedDisciplines,
    fetchQuestions,
    fetchQuestionsWithMedia,
    fetchAllMedia,
    fetchSubscriptions,

    createDiscipline,
    setDisciplineImage,

    uploadCsv,
    uploadMedia,
    prefixImageUrl,

    fetchBattles,
    fetchBattle,
    fetchBattleLeaderboard,
    // createBattle,
    uploadBattle,
    startBattle,
    stopBattle,

    fetchUsers,
    fetchUser,
    fetchUserVouchers,
    searchUsers,
    downloadUsersCsv,

    fetchPromos,
    uploadPromo,

    runQualityChecks,

    fetchVouchers,
    fetchUserSubscriptions,
    createVouchers,

    migrateUser
};
